export default "__VITE_ASSET__6837d033__"